import type { NDateLocale } from './enUS'
import { kk } from 'date-fns/locale'

const dateKkKZ: NDateLocale = {
  name: 'kk-KZ',
  locale: kk
}

export default dateKkKZ
